export const TAB_HEIGHT = 70;
export const TAB_CONTAINER_ACTIVE_CLASS = 'active';
export const TAB_CONTAINER_STICKY_CLASS = 'sticky';
export const TAB_CONTAINER_STUCK_CLASS = 'stuck';
